import React from 'react';
import { Link } from 'react-router';
import { useTranslation } from '../contexts/LanguageContext';
import { useGameStore } from '../store/gameStore';

// Import version from package.json
const packageJson = require('../../package.json');

export const BottomControls: React.FC = () => {
  const winner = useGameStore((state) => state.winner);
  const { t } = useTranslation();

  return (
    <div className="bottom-controls">
      {winner && (
        <Link 
          to="/start-game"
          className="landing-link-button"
          style={{
            backgroundColor: '#28a745',
            marginBottom: '10px'
          }}
        >
          {t.startNewGame}
        </Link>
      )}
      
      <div className="version-info">
        v{packageJson.version}
      </div>
    </div>
  );
};
